import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDocumentDocProps } from './IconDocumentDoc.types'
import * as Styled from './styles/IconDocumentDoc.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentDoc: FC<IconDocumentDocProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentDocProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDocumentDocProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M7.441 11.625v2.816h.625s1.309.184 1.309-1.441c0-1.5-1.313-1.375-1.313-1.375Zm5.622 1.41c0-.828-.485-1.5-1.083-1.5-.601 0-1.085.672-1.085 1.5 0 .832.484 1.504 1.085 1.504.598 0 1.082-.672 1.082-1.504Zm3.32 1.156a.949.949 0 0 1-.711.348c-.613 0-1.113-.676-1.113-1.5 0-.828.5-1.5 1.113-1.5.332.012.633.184.812.461M5.637 6.543H9.5V2.797'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M10.355 2.543a2.15 2.15 0 0 0-1.39.512l-2.703 2.32a2.124 2.124 0 0 0-.742 1.617v12.465c0 1.098.902 2 1.742 2h9.218c1.36 0 2-.902 2-2V2.543Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDocumentDoc
